import { cloneDeep } from 'lodash';
import { DELETE_SITE_CARD_SUCCESS } from '../site_card/Types';
import {
    SET_PROJECT_STRUCTURE,

    EXPORT_PROJECT_COLUMN_REQUEST,
    EXPORT_PROJECT_COLUMN_SUCCESS,
    EXPORT_PROJECT_COLUMN_FAILURE,

    // Kanban
    CREATE_SITE_CARD_COLUMN_REQUEST,
    CREATE_SITE_CARD_COLUMN_SUCCESS,
    CREATE_SITE_CARD_COLUMN_FAILURE,

    UPDATE_SITE_CARD_COLUMN_REQUEST,
    UPDATE_SITE_CARD_COLUMN_SUCCESS,
    UPDATE_SITE_CARD_COLUMN_FAILURE,

    DELETE_SITE_CARD_COLUMN_REQUEST,
    DELETE_SITE_CARD_COLUMN_SUCCESS,
    DELETE_SITE_CARD_COLUMN_FAILURE,

    MOVE_SITE_CARD_COLUMN_REQUEST,
    MOVE_SITE_CARD_COLUMN_SUCCESS,
    MOVE_SITE_CARD_COLUMN_FAILURE,

    MOVE_SITE_CARD_REQUEST,
    MOVE_SITE_CARD_SUCCESS,
    MOVE_SITE_CARD_FAILURE,

    PING_PROJECT_KANBAN_REQUEST,
    PING_PROJECT_KANBAN_SUCCESS,
    PING_PROJECT_KANBAN_FAILURE,

    SORT_KANBAN_REQUEST,
    SORT_KANBAN_SUCCESS,
    SORT_KANBAN_FAILURE,

    SORT_SITE_CARDS_REQUEST,
    SORT_SITE_CARDS_SUCCESS,
    SORT_SITE_CARDS_FAILURE,

    COLUMN_SCROLL_POSITION_UPDATE,
    KANBAN_SCROLL_POSITION_UPDATE,
} from './Types';
import { CurrentProject, IProjectAction, IProjectReducerState, Structure, IColumnsScrollPosition } from './projectTypes';

export default function reducer (state: IProjectReducerState, action: IProjectAction) {
    switch (action.type) {
        case SET_PROJECT_STRUCTURE:
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: { ...action.structure }
                }
            };
        // Just going to put this here, do we need to hold export in redux?
        // Theoretically could we allow a user to mash a button and export multiple times? Not desirable but do see in plently of other applications
        case EXPORT_PROJECT_COLUMN_REQUEST:
            return {
                ...state,
                isExporting: true,
                error: null
            };
        case EXPORT_PROJECT_COLUMN_SUCCESS:
            return {
                ...state,
                isExporting: false,
                error: null
            };
        case EXPORT_PROJECT_COLUMN_FAILURE:
            return {
                ...state,
                isExporting: false,
                error: action.error
            };
        
        // Kanban Columns
        case CREATE_SITE_CARD_COLUMN_REQUEST:
            return { ...state };
        case CREATE_SITE_CARD_COLUMN_SUCCESS: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            newStructure.columns[action.siteCardColumn.id] = {
                ...action.siteCardColumn,
                resourceIds: []
            };
            newStructure.columnOrder.push(action.siteCardColumn.id);
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case CREATE_SITE_CARD_COLUMN_FAILURE:
            return { ...state };
        case UPDATE_SITE_CARD_COLUMN_REQUEST:
            return { ...state };
        case UPDATE_SITE_CARD_COLUMN_SUCCESS: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            newStructure.columns[action.siteCardColumn.id] = {
                ...newStructure.columns[action.siteCardColumn.id],
                ...action.siteCardColumn
            };
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case UPDATE_SITE_CARD_COLUMN_FAILURE:
            return { ...state };
        case MOVE_SITE_CARD_COLUMN_REQUEST: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            newStructure.columnOrder.splice(action.srcIndex, 1);
            newStructure.columnOrder.splice(action.dstIndex, 0, action.columnId);
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case MOVE_SITE_CARD_COLUMN_SUCCESS: 
            return { ...state };
        case MOVE_SITE_CARD_COLUMN_FAILURE:
            return { ...state };
        case DELETE_SITE_CARD_COLUMN_REQUEST:
            return { ...state };
        case DELETE_SITE_CARD_COLUMN_SUCCESS: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            const idx = newStructure.columnOrder.findIndex(id => id === action.columnId);
            newStructure.columnOrder.splice(idx, 1);
            delete newStructure.columns[action.columnId];
            if (newStructure.columnsScrollPosition) delete newStructure.columnsScrollPosition[action.columnId];
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case DELETE_SITE_CARD_COLUMN_FAILURE:
            return { ...state };

        case MOVE_SITE_CARD_REQUEST: { 
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            const srcColumn = newStructure.columns[action.srcColumnId];
            const dstColumn = newStructure.columns[action.dstColumnId];
            srcColumn.resourceIds.splice(action.srcIndex, 1);
            dstColumn.resourceIds.splice(action.dstIndex, 0, action.siteCardId);
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case MOVE_SITE_CARD_SUCCESS:
            return { ...state };
        case MOVE_SITE_CARD_FAILURE:
            return { ...state };
        case SORT_SITE_CARDS_REQUEST: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            newStructure.columns[action.columnId].resourceIds = action.resourceIdsNewOrder;
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case SORT_SITE_CARDS_SUCCESS:
            return { ...state };
        case SORT_SITE_CARDS_FAILURE:
            return { ...state };

        // TODO Do we need create from feature analysis as well? probably?
        case DELETE_SITE_CARD_SUCCESS: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            for (const columnId of newStructure.columnOrder) {
                const idx = newStructure.columns[columnId].resourceIds.findIndex(id => id === action.id);
                if(idx !== -1) {
                    newStructure.columns[columnId].resourceIds.splice(idx, 1);
                }
            }
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case PING_PROJECT_KANBAN_REQUEST:
            return { 
                ...state,
                isFetchingSiteCardKanban: true
            };
        case PING_PROJECT_KANBAN_SUCCESS: {
            const currentStructure = cloneDeep(state?.currentProject?.structure) as Structure;       
            const newStructure = action.project.structure as Structure;
            const scrollPosition = {} as IColumnsScrollPosition;
            newStructure.columnOrder.forEach(columnId => {
                if(currentStructure.columnsScrollPosition && currentStructure.columnsScrollPosition[columnId]){
                    scrollPosition[columnId] = currentStructure.columnsScrollPosition[columnId];
                } else {
                    scrollPosition[columnId] = 0;
                }
            });
            newStructure.columnsScrollPosition = scrollPosition;
            return {
                ...state,
                isFetchingSiteCardKanban: false,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure,
                    numSiteCards: action.project.numSiteCards,
                    siteCardKanbanUpdatedAt: action.project.siteCardKanbanUpdatedAt
                }
            };
        }
        case PING_PROJECT_KANBAN_FAILURE:
            return { 
                ...state,
                isFetchingSiteCardKanban: false
            };
        case SORT_KANBAN_REQUEST:
            return { 
                ...state,
                isSortingKanban: true
            };
        case SORT_KANBAN_SUCCESS: {
            return {
                ...state,
                isSortingKanban: false,
                currentProject: {
                    ...state.currentProject,
                    structure: action.project.structure,
                    numSiteCards: action.project.numSiteCards,
                    siteCardKanbanUpdatedAt: action.project.siteCardKanbanUpdatedAt
                }
            };
        }
        case SORT_KANBAN_FAILURE:
            return { 
                ...state,
                isSortingKanban: false
            };        
        case COLUMN_SCROLL_POSITION_UPDATE: {
            const newStructure = cloneDeep(state?.currentProject?.structure) as Structure;
            if(newStructure.columnsScrollPosition) newStructure.columnsScrollPosition[action.columnId] = action.scrollPosition;
                        
            return {
                ...state,
                currentProject: {
                    ...state.currentProject,
                    structure: newStructure
                }
            };
        }
        case KANBAN_SCROLL_POSITION_UPDATE: {
            const newCurrentProject = cloneDeep(state?.currentProject) as CurrentProject;
            newCurrentProject.kanbanBoardScrollPosition = action.scrollPosition;          
            return {
                ...state,
                currentProject: newCurrentProject,
            };
        }   
        default:
            return state;
    }
}
